let ValidatorJS = require('validatorjs');
import Router from '../routes'

class Validator {
	constructor(data, rules, messages = {}) {
		this.validator = new ValidatorJS(data, rules, messages);
	}

	passes(callback) {
		this.validator.passes(() => {
			Router.app.$broadcast('passedValidation');

			callback();
		});

		this.validator.fails(() => {
			Router.app.$broadcast('failedValidation', this.validator.errors);
		});
	}
}

export default Validator;

export const validate = (data, rules, messages = {}) => {
	return new Validator(data, rules, messages);
};



// WEBPACK FOOTER //
// ./src/utils/validator.js